import { API_URLS } from '@services/apiRoutes'
import { clearsEmptyProperties } from '@utils/functions/clearsEmptyProperties'

import type {
  GetClByUserCodeRequestProps,
  GetClDetailsRequestProps,
  GetUsersRequestProps,
  SaveUserProfileRequestProps
} from './types'

import * as apiFunction from '@services/apiFunctions'

export const updateUserAdmin = async (userId: number, isAdmin: boolean) => {
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.auth.users}/${userId}/admin`,
    method: 'PUT',
    body: {
      isAdmin
    }
  })
}

export const saveUserProfile = async ({ routeParams, bodyParams }: SaveUserProfileRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.auth.users}/${routeParams.id}/profile`,
    method: 'PUT',
    body
  })
}

export const getClDetails = async (params: GetClDetailsRequestProps) => {
  return await apiFunction.apiRequestWithQueryParams({
    url: `${API_URLS.auth.users}/busca/usuarios/${params.userCode}/centros-lucro/${params.profitCenterId}`,
    method: 'GET'
  })
}

export const getClByUserCode = async ({ routeParams, bodyParams }: GetClByUserCodeRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.auth.users}/busca/${routeParams.userCode}/centros-de-lucro`,
    method: 'POST',
    body
  })
}

export const getUsers = async ({ bodyParams }: GetUsersRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.auth.users}/busca`,
    method: 'POST',
    body
  })
}
